/**
 * @fileoverview This file defines shared types and enums for the telemetry module.
 * It helps break circular dependencies between telemetry and other modules.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CountMetric: function() {
        return CountMetric;
    },
    SummaryMetric: function() {
        return SummaryMetric;
    }
});
var CountMetric;
(function(CountMetric) {
    CountMetric[// go/keep-sorted start
    // AnomalyDataRaceTraceNotFound - Anomalies miss on graph due to race condition,
    // trace was not there yet during anomalies assigment.
    "AnomalyDataRaceTraceNotFound"] = 'fe_anomaly_data_race_trace_not_found';
    CountMetric["ConfirmedRegressionInvalidPayload"] = 'fe_confirmed_regression_invalid_payload';
    CountMetric["DataFetchFailure"] = 'fe_data_fetch_failure';
    CountMetric["ExistingBugDialogSkBugIdUsedAsAnomalyKey"] = 'fe_exisitng_dialog_sk_bug_id_used_as_anomaly_key';
    CountMetric["ExploreMultiV2Visit"] = 'fe_explore_multi_v2_page_visit_count';
    CountMetric["FrontendErrorReported"] = 'fe_errors_reported_count';
    CountMetric["MultiGraphVisit"] = 'fe_multi_graph_page_visit_count';
    CountMetric["ReportPageVisit"] = 'fe_report_page_visit_count';
    CountMetric["SIDRequiringActionTaken"] = 'fe_sid_requiring_action_taken';
    CountMetric["TriageActionTaken"] = 'fe_triage_action_taken';
})(CountMetric || (CountMetric = {}));
var SummaryMetric;
(function(SummaryMetric) {
    SummaryMetric[// go/keep-sorted start
    "GoogleGraphPlotTime"] = 'fe_google_graph_plot_time_s';
    SummaryMetric["MultiGraphDataLoadTime"] = 'fe_multi_graph_data_load_time_s';
    SummaryMetric["ReportAnomaliesTableLoadTime"] = 'fe_report_anomalies_table_load_time_s';
    SummaryMetric["ReportChartContainerLoadTime"] = 'fe_report_chart_container_load_time_s';
    SummaryMetric["ReportGraphChunkLoadTime"] = 'fe_report_graph_chunk_load_time_s';
    SummaryMetric["ReportPageLoadTime"] = 'fe_report_page_load_time_s';
    SummaryMetric["SingleGraphLoadTime"] = 'fe_single_graph_load_time_s';
    SummaryMetric["V2GraphPlotTime"] = 'fe_v2_graph_plot_time_s';
})(SummaryMetric || (SummaryMetric = {}));
